import * as React from "react";

import { IconButton, Snackbar } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

import { User } from "Utility/User";
import { IHttpRequest, Status, useHttp } from "Utility/useHttp";

import { IFavoriteQuilt } from "Model/IFavoriteQuilt";

interface IProps {
    readonly user: User;
    readonly favorite: IFavoriteQuilt;
    
    readonly onDeleted: () => void;
}

export function DeleteButton(props: IProps): React.ReactElement {
    const [request, setRequest] = React.useState<IHttpRequest | null>(null);
    const [snackMessage, setSnackMessage] = React.useState<string | null>(null);

    const status = useHttp(request);
    const loading = status.status === Status.Loading;

    const onClick = () => {
        if (loading) {
            return;
        }

        setRequest({
            method: "delete",
            url: `/api/favorites?favoriteId=${props.favorite.id}`,
            user: props.user
        });
    };

    const onDeleted = props.onDeleted;

    React.useEffect(() => {
        switch (status.status) {
            case Status.Complete:
                setRequest(null);
                onDeleted();
                break;
            case Status.Error:
                setSnackMessage(`Failed to delete quilt: ${status.message}`);
                setRequest(null);
                break;
        }
    },
    [status, onDeleted]);

    return (
        <>
            <IconButton disabled={loading} onClick={onClick} size="small">
                {request === null && <DeleteOutlineIcon fontSize="inherit" /> }
                {request !== null && <HourglassEmptyIcon fontSize="inherit" /> }
            </IconButton>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackMessage !== null}
                autoHideDuration={3000}
                onClose={() => setSnackMessage(null)}
                message={snackMessage}
            />
        </>
    );
}